import { render } from "./statsTwo.vue?vue&type=template&id=4b3c4b0e"
import script from "./statsTwo.vue?vue&type=script&lang=js"
export * from "./statsTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__